import { cn } from "@/lib/helpers/cn";

type TimelineRecordElementProps = {
  children: React.ReactNode;
};

export function TimelineRecordElement({ children }: TimelineRecordElementProps) {
  return (
    <li
      className={cn(
        "tw:relative tw:ms-4 tw:flex tw:gap-4 tw:rounded-lg tw:border tw:border-fill-quaternary tw:p-4",
        "tw:first:before:absolute tw:first:before:top-0 tw:first:before:-left-4.5 tw:first:before:h-5.5 tw:first:before:w-px tw:first:before:bg-fill-white",
        "tw:last:after:absolute tw:last:after:top-7 tw:last:after:bottom-0 tw:last:after:-left-4.5 tw:last:after:w-px tw:last:after:bg-fill-white",
      )}
    >
      <div className="tw:absolute tw:-inset-s-6 tw:h-3 tw:w-3 tw:rounded-full tw:bg-fill-quaternary"></div>
      {children}
    </li>
  );
}
